import { createSelector } from '@reduxjs/toolkit';
import { getStructure } from './Structure.selector';
import { NormalizedGroup } from '../GroupsAdapter';

export const getAllRegions = createSelector([getStructure], (structure) => {
  return structure.data?.regions.map(
    (region) => structure.data?.entities.groups[region] as NormalizedGroup
  );
});
